/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import { Controller, useFormState } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import products from '../products';
import templateFieldNames from './templateFieldNames';

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function Step2ProductType({ index, updateWorkflowStatus, form, signalNext, setSignalNext }) {
  const { t: tI } = useTranslation('addAccount', { keyPrefix: 'pension' });
  const productListRef = React.useRef(null);

  // icon and id are in products, need to add the translations here
  const productList = products.pension.map((p) => ({
    ...p,
    name: tI(`product.${p.id}.name`),
    description: tI(`product.${p.id}.description`),
  }));

  const { watch, control, setValue, trigger } = form;
  const { isValid } = useFormState({ control, name: ['product'] });

  //--------------------------------------------------------------------------------
  // synchronise form state with parent
  //--------------------------------------------------------------------------------

  useEffect(() => {
    updateWorkflowStatus(index, isValid);
  }, [isValid]);

  //--------------------------------------------------------------------------------
  // subscribe to signal from parent that the user has clicked the "next" button
  // (and then trigger all validations to show errors)
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (signalNext) {
      trigger();
      setSignalNext(false);
    }
  }, [signalNext, trigger, setSignalNext]);

  //---------------------------------------------------------------------------------------------
  // react to changes in the product field; if user selects a new product
  // apply the changes to other form fields
  //---------------------------------------------------------------------------------------------

  // watch all fields determined by a pension template array members
  const templateFieldsValues = watch(templateFieldNames); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])

  //---------------------------------------------------------------------------------------------
  // if the user selects a new product, apply the product values to the form fields
  //---------------------------------------------------------------------------------------------

  const severalSetValueInProgress = React.useRef(false); // to avoid the next useEffect to trigger immediatelly after the first setValue

  const product = watch('product'); // this field's value is the product ID

  // When no product is selected, keep keyboard focus within the step so the first tab lands on the first product option.
  useEffect(() => {
    if (!product && productListRef.current) {
      productListRef.current.focus({ preventScroll: true });
    }
  }, [product]);

  useEffect(() => {
    // get products.pension and apply everything except id, type, Icon, link onto form state
    const selectedProduct = products.pension.find((p) => p.id === product);
    if (selectedProduct && selectedProduct.id !== 'custom') {
      const { id, type, Icon, link, ...rest } = selectedProduct;
      severalSetValueInProgress.current = true;
      Object.entries(rest).forEach(([key, value]) => {
        setValue(key, value);
      });
      // let all the code in the loop run its course and then set the flag to false (1ms delay is not enough, seems to be working ok for 100ms)
      setTimeout(() => {
        severalSetValueInProgress.current = false;
      }, 100);
    }
  }, [product]);

  //---------------------------------------------------------------------------------------------
  // set product to "custom" if the user changes any of the connected fields
  //---------------------------------------------------------------------------------------------

  // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
  useEffect(() => {
    if (product && product !== 'custom' && !severalSetValueInProgress.current) {
      // if a defined product is selected, check if all product fields in the state are equal to the template fields
      const selectedProduct = productList.find((p) => p.id === product);
      // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
      const allFieldsEqual = templateFieldsValues.every((value, idx) => {
        const fieldName = templateFieldNames[idx];
        // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
        return value === selectedProduct[fieldName];
      });
      if (!allFieldsEqual) setValue('product', 'custom');
    }
  }, [templateFieldsValues]);

  //---------------------------------------------------------------------------------------------
  // render the form
  //---------------------------------------------------------------------------------------------

  return (
    <div className="pt-4 sm:pt-0">
      <h3 className="text-xl md:text-2xl font-bold leading-6 text-gray-900">{tI('wizardSteps.selectProduct.title')}</h3>
      <p className="mt-1 pb-4 text-sm text-gray-500">{tI('wizardSteps.selectProduct.subtitle')}</p>

      <div
        className="py-3 lg:py-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8"
        tabIndex={-1}
        ref={productListRef}
      >
        <Controller
          name="product"
          control={control}
          render={({ field: { onChange, onBlur, value } }) => {
            const computedValue = productList.find((item) => item.id === value); // this will be undefined if value is not in list

            return (
              <>
                {productList.map((item, count) => (
                  <button
                    key={item.name}
                    onClick={() => onChange(item.id)}
                    tabIndex={count + 1}
                    type="button"
                    className={` ${
                      item.id === computedValue?.id ? 'ring-2 ring-brandBlue-500' : ''
                    } flex flex-col border bg-white border-gray-100 shadow-sm rounded-md p-4 cursor-pointer hover:border-gray-300`}
                  >
                    <dt className="flex items-start gap-x-3 text-base font-semibold leading-7 text-gray-900 min-h-[3rem]">
                      <item.Icon className="h-5 w-5 flex-none text-brandBlue-500" aria-hidden="true" />
                      <span className="text-left leading-5">{item.name}</span>
                    </dt>
                    <dd className="mt-2 flex flex-auto flex-col text-base leading-7 text-gray-600">
                      <p className="text-left flex-auto text-sm">{item.description}</p>
                      <p className="mt-6">
                        {product !== item.id && (
                          <div className="text-left text-sm font-semibold leading-6 text-brandBlue-500">
                            Select
                            {' '}
                            <span aria-hidden="true">→</span>
                          </div>
                        )}
                      </p>
                    </dd>
                  </button>
                ))}
              </>
            );
          }}
        />
      </div>
    </div>
  );
}

Step2ProductType.propTypes = {
  index: PropTypes.number.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  signalNext: PropTypes.bool,
  setSignalNext: PropTypes.func,
};
Step2ProductType.defaultProps = {
  signalNext: undefined,
  setSignalNext: () => {},
};

export default Step2ProductType;
